import {roleSystemRoute} from './route_utilities'

import Countries from '../../views/countries/Countries.vue'
import Country from '../../views/countries/Country.vue'
import CountryGeneral from '../../views/countries/CountryGeneral.vue'
import CountryCities from '../../views/countries/CountryCities.vue'
import CreateCountry from '../../views/countries/CreateCountry.vue'
import CountryTranslations from '../../views/countries/CountryTranslations.vue'

export const countries = {
      path: 'countries',
      name: 'Countries',
      component: Countries,
      meta: {
          title: "ulkeler",
          domain:"countries",
          accessroles:["admin","brand","auditor","planner"],
        },
      }


export const country =  {
      path: 'country/:id',
      name: 'Country',
      component: Country,
      redirect: { name: 'CountryGeneral' },
      meta: {
          title: "ulke",
          domain:"countries",
          accessroles:["admin","brand","auditor","planner"],
        },
        children:[
         {
          path: 'general',
          name: 'CountryGeneral',
          component: CountryGeneral,
          meta: {
              title: "genel",
              domain:"countries"
            },
          },
          {
          path: 'cities',
          name: 'CountryCities',
          component: CountryCities,
          meta: {
              title: "sehirler",
              domain:"countries"
            },
          },          
          {
          path: 'translations',  
          name: 'CountryTranslations',
          component: CountryTranslations,
          meta: {
              title: "ceviriler",
              preloader:true,
              domain:"countries"
            },
          },


        ]        
      }

export const create_country ={
      path: 'country',
      name: 'CreateCountry',
      component: CreateCountry,
      meta: {
          title: "yeni_ulke",
          domain:"countries"
        },
      }